import { render, staticRenderFns } from "./LicenceManager.vue?vue&type=template&id=71b6ceaa&"
import script from "./LicenceManager.vue?vue&type=script&lang=js&"
export * from "./LicenceManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports